module.exports = __webpack_public_path__ + "repair.41da25d3.png";